import { defineFieldTypeTemplate } from '#layers/data-model/utils/field-types/define';

export default defineFieldTypeTemplate({
	type: 'primitive',
	id: 'boolean',
	name: '$t:field_types.boolean.name',
	description: '$t:field_types.boolean.description',
	icon: 'lucide:toggle-left',
	sort: 400,
	keywords: ['toggle', 'switch', 'true', 'false', 'checkbox'],
	supportedPrimitiveTypes: ['boolean'],
});
